import { css } from 'styled-components'
import type { CSS } from 'types/style'

export const bgBlur: CSS = css`
  backdrop-filter: blur(32px);
`

export default bgBlur
